import { Check } from "lucide-react";
import { useT } from "../i18n";

export default function AdminReportsPanel({ reports, locale, onResolve }) {
  const { t } = useT();
  return (
    <section className="mt-8 flex flex-col gap-4" data-testid="admin-reports-section">
      {reports.length === 0 && <p data-testid="admin-reports-empty" className="text-sm text-[#6B7280]">{t("admin.reports.empty")}</p>}
      {reports.map((r) => (
        <article key={r.id} data-testid={`admin-report-${r.id}`}
          className={`bg-white rounded-xl border p-5 flex flex-col gap-2 ${r.resolved ? "border-black/5 opacity-60" : "border-[#FBBF24]/60"}`}>
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <h3 className="font-bold text-[#1F2937]" style={{ fontFamily: "Manrope" }}>{r.pro_name}</h3>
            <span className="text-xs text-[#6B7280]">{new Date(r.created_at).toLocaleDateString(locale)}</span>
          </div>
          <p className="text-sm text-[#1F2937]/80">{r.message}</p>
          {r.reporter_contact && <p className="text-xs text-[#6B7280]">{t("report.contact")}: {r.reporter_contact}</p>}
          {!r.resolved ? (
            <button data-testid={`admin-resolve-${r.id}`} onClick={() => onResolve(r)}
              className="self-start flex items-center gap-1.5 text-xs font-semibold px-3.5 py-2 rounded-full bg-[#0D4045] text-[#FDFBF7] hover:bg-[#0a3237] transition-colors duration-200">
              <Check size={13} /> {t("admin.resolve")}
            </button>
          ) : (
            <span className="text-xs font-semibold text-[#065F46]">{t("admin.resolved")}</span>
          )}
        </article>
      ))}
    </section>
  );
}
